import { useState, useEffect } from 'react';
import { MapContainer, TileLayer, Marker, useMapEvents } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';

// Fix for default markers in react-leaflet
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png',
  iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
});

function LocationMarker({ onLocationSelect }) {
  const [position, setPosition] = useState(null);

  useMapEvents({
    click(e) {
      const { lat, lng } = e.latlng;
      setPosition(e.latlng);
      onLocationSelect({ lat, lng });
    },
  });

  return position === null ? null : <Marker position={position}></Marker>;
}

const LocationPicker = ({ onLocationSelect, onClose }) => {
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [currentLocation, setCurrentLocation] = useState(null);

  // Get user's current location for initial map center
  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setCurrentLocation({
            lat: position.coords.latitude,
            lng: position.coords.longitude
          });
        },
        (error) => {
          console.error("Error getting location:", error);
          // Default to India if location access denied
          setCurrentLocation({ lat: 20.5937, lng: 78.9629 });
        }
      );
    } else {
      // Default to India if geolocation not supported
      setCurrentLocation({ lat: 20.5937, lng: 78.9629 });
    }
  }, []);

  const handleMapLocationSelect = (location) => {
    setSelectedLocation(location);
  };

  const handleConfirm = () => {
    if (selectedLocation) {
      // Create Google Maps URL
      const mapsUrl = `https://www.google.com/maps?q=${selectedLocation.lat},${selectedLocation.lng}`;
      onLocationSelect(mapsUrl);
    }
  };

  if (!currentLocation) {
    return (
      <div className="location-picker-modal">
        <div className="location-picker-content">
          <div className="map-loading">
            <p>Loading map...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="location-picker-modal">
      <div className="location-picker-content">
        <div className="location-picker-header">
          <h3>Select Your Location</h3>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>
        
        <div className="leaflet-map-container">
          <MapContainer 
            center={[currentLocation.lat, currentLocation.lng]} 
            zoom={13} 
            style={{ height: '400px', width: '100%' }}
          >
            <TileLayer
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            />
            <LocationMarker onLocationSelect={handleMapLocationSelect} />
          </MapContainer>
        </div>

        <div className="location-picker-footer">
          <p className="selected-location-info">
            {selectedLocation 
              ? `Selected Location: ${selectedLocation.lat.toFixed(6)}, ${selectedLocation.lng.toFixed(6)}`
              : "Click anywhere on the map to select your location"
            }
          </p>
          <div className="location-buttons">
            <button onClick={onClose} className="cancel-btn">
              Cancel
            </button>
            <button 
              onClick={handleConfirm} 
              className="confirm-btn"
              disabled={!selectedLocation}
            >
              Save Location
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LocationPicker;